<dashboard-dialog-frame class="engagement-viewer-dialog" header="View Engagement" [actions]="actions()" [dialogRef]="dialogRef">

	<kendo-tabstrip id="engagementViewerTabStrip" class="p-2 pb-0 h-100">

		<kendo-tabstrip-tab title="Overview" [selected]="true">
			<ng-template kendoTabContent>
				<engagement-viewer-overview-part></engagement-viewer-overview-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Interactions">
			<ng-template kendoTabContent>
				<engagement-viewer-interactions-part [dialogBodyHeight]="dialogContext.dimensions().bodyHeight"></engagement-viewer-interactions-part>
			</ng-template>
		</kendo-tabstrip-tab>

	</kendo-tabstrip>

</dashboard-dialog-frame>